import axios from "axios";
import { server } from "../server";

const getAuthHeader = () => {
  const token = localStorage.getItem("dbToken");
  return { Authorization: `Bearer ${token}` };
};

export const createFolderAPI = async (name, parentId = null) => {
  try {
    const response = await axios.post(
      `${server}/drive/folder`,
      {
        name,
        parentId: parentId || null,
      },
      {
        headers: {
          ...getAuthHeader(),
          "Content-Type": "application/json",
          "accept": "*/*",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getFoldersAPI = async () => {
  try {
    const response = await axios.get(
      `${server}/drive/folders?userWise=true&sharedWithMe=false&parentFoldersOnly=true`,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getFolderContentAPI = async (id) => {
  try {
    const response = await axios.get(`${server}/drive/folder/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const uploadFileAPI = async (file, folderId = null) => {
  try {
    const formData = new FormData();
    formData.append("File", file);
    if (folderId) {
      formData.append("FolderId", folderId);
    }

    const response = await axios.post(`${server}/drive/file`, formData, {
      headers: {
        ...getAuthHeader(),
        "Content-Type": "multipart/form-data",
        "accept": "*/*",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const viewFileAPI = (id) => {
  return `${server}/drive/file/${id}/view`;
};

export const downloadFileAPI = (id) => {
  return `${server}/drive/file/${id}/download`;
};

export const renameFileAPI = async (id, newName) => {
  try {
    const response = await axios.patch(
      `${server}/drive/file/${id}/rename`,
      { displayName: newName },
      {
        headers: {
          ...getAuthHeader(),
          "Content-Type": "application/json",
          "accept": "*/*",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getUsersAPI = async () => {
  try {
    const response = await axios.get(`${server}/auth/users`, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const grantAccessAPI = async (userId, resourceId, resourceType, permission) => {
  try {
    const response = await axios.post(
      `${server}/drive/access/grant`,
      {
        grantedToUserId: userId,
        resources: [
          {
            resourceType: resourceType,
            resourceId: resourceId,
          },
        ],
        permission: permission,
      },
      {
        headers: {
          ...getAuthHeader(),
          "Content-Type": "application/json",
          "accept": "*/*",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
